export enum Endpoint {
  EMPLOYER_WEB = 'employer',
  PUBLIC = 'public',
}
